import { Injectable } from '@angular/core';
import { ElementService } from '../element/element.service';
//import * as bootstrap from 'bootstrap';
declare let bootstrap: any;

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  isLoading: boolean = false;

  constructor(
    public srvElement: ElementService,
  ) { }

  modalOpen(identify: any) {
    const dataElement = this.srvElement.data(identify);
    if (dataElement && dataElement !== null) {
      const modalInfo = new bootstrap
      .Modal(dataElement);
      modalInfo.show();
    }
  }

  modalClose(identify: any) {
    const dataElement = this.srvElement.data(identify);
    if (dataElement && dataElement !== null) {
      const modalInfo = new bootstrap
      .Modal(dataElement);
      modalInfo.hide();
    }
  }

  spinner(response: boolean) {
    // Obtener el estado del spinner
    this.isLoading = response;
    // Definir el id del elemento
    let identify = 'loadingSpinner';
    // Obtener el elemento con el id asignado
    const spinner = this.srvElement.data(identify);
    // Spinner visible durante un tiempo determinado
    if (spinner &&spinner !== null) {
      // Establecer visualizacion
      let display = 'none';
      // Aplicar visibilidad al elemento
      spinner.style.display = display;
    }
    // Retornar el estado
    return this.isLoading;
  }
}
